<app-registrations-add-multiple
  [ofwcaObject]="ofwcaObject"
  [contractObject]="contractObject"
  (registrationCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
></app-registrations-add-multiple>
